import { Box, Button, Typography } from "@mui/material"
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom"
import IconWheel from "./IconWheel";


const DesktopNavBar: React.FC  = () => {
    const { t } = useTranslation();
    const navRoutes = [
        { link: "/Wheels", text: t("common.wheels") },
        { link: "/Rollers", text: t("common.rollers") },
        { link: "/Accessories", text: t("common.accessories") }
        ];

    return (
        <>
        <Box sx={{ display: { md: "flex" } }}>
        <Typography variant="h5" noWrap>
          <NavLink
            to="/"
            style={{ textDecoration: "none", color: "white" }}
          >
            <IconWheel />
            <Box sx={{ display: { xs: "inline", md: "inherit", fontWeight: "bold" } }}>
              {t("common.appname")}
            </Box>
          </NavLink>
        </Typography>
      </Box>
      <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "flex" } }}>
        {navRoutes.map((route) => {
            return (
                <NavLink key={route.text} to={route.link} style={{ textDecoration: "none" }} end>
                {({ isActive }) => (
                  <Button sx={{ my: 2, display: "block", marginTop: "20px", color: isActive ? "black" : "white"}} >
                    {route.text}
                    </Button>
                )}
              </NavLink>
            )
        })}
      </Box>
      </>
    )
}

export default DesktopNavBar;